import React from 'react';
import { History } from 'history';
import { Grid } from '@mui/material';
import { Button, Input, InputDate, InputMoney, InputMultiline, InputNumber, InputPicklist } from '../../components';
import BaseCreateEdit from '../base/base-create-edit.component';
import BaseView from '../base/base-view.component';
import BaseList from '../base/base-list.component';
import Model from './transactiondetail-model';  //editable..
import UserModel from '../user/user-model';
import ProductModel from '../product/product-model';
import TransactionModel from '../transaction/transaction-model';
import TransactionCreate from '../transaction/transaction-create.component';
import SchedulePicklist from '../schedule/schedule-picklist.component';
import AppService from '../../services/app.service';
                
interface IProps { 
    history: History;
    productId: number;
    onLoad?: (data: any) => void;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowTransaction: any;
    producttypeType: string;
    isCart: boolean;
    save: boolean;
}

export default class TransactiondetailCreatePublic extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowTransaction: null,
            producttypeType: '',
            isCart: false,
            save: false,
        }
        
        this.onChange = this.onChange.bind(this);
    }

    private isMobile: boolean = AppService.isMobile();
    private validations : any = Model.validations;

    private onLoad = (data: any) => {
        if (data) {
            this.setState({datarow: data});
            this.props.onLoad?.(data);
        }
    }

    private onLoadProduct = (data: any) => {
        const pricetype = this.state.datarowTransaction?.transactiontypePricetype || 'pricesale';
        const price = pricetype === 'pricesale'? data?.pricesale : data?.pricebase;

        this.setState({ datarow: {
            ...new Model({...this.state.datarow, 
                'product': data, 'price': price, 'value': price * this.state.datarow.qty, 
                'schedule': null, 'startdate': data.scheduleLength === 0? AppService.dateCurrent() : AppService.dateISO(data.startdate, '', 1)
            }),
            'transaction': this.state.datarowTransaction?.id,   
        }});

        this.validations = [...Model.validations, { name: 'qty', maxValue: data?.qty }];
        if (data.scheduleLength > 0) 
            this.validations = [...this.validations, { name: 'schedule', required: true }];

        if (this.state.datarowTransaction?.id === 0)
            this.setState({ datarowTransaction: { ...this.state.datarowTransaction, 'name': data?.name, 'description': data?.name, 'customer': +UserModel.getUserPersonalinfo()} });
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: {...this.state.datarow, 'schedule': data?.id, 'scheduleCaption': data?.name, 'scheduleDisableday': data?.disableDay, 'startdate': data?.availableDate}});
    }

    private onLoadAllTransaction = async(data: any) => {
        await this.setState({datarowTransaction: data?.[0] || TransactionModel.defaultValue()});
        await this.setState({datarow: {...this.state.datarow, transaction: data?.[0]?.id}});
    }

    private onError = (data: any) => {
        this.setState({ errors: data, save: false});
    }

    private onClickSave = (data: any) => {
        this.setState({isCart: data, save: true});
    }
    
    private onSave = (data: any) => {
        this.setState({datarow: {...this.state.datarow, id: data.id}, isCart: false, save: false});
        if (!this.state.isCart && this.state.datarow.transaction > 0) 
            this.props.history.push('/transaction', {id: this.state.datarow.transaction});
    }
    
    private onSaveTransaction = (data: any) => {
        if (data) this.onLoadAllTransaction([data])
    }

    private onChange(fieldName: string, value?: string) { 
        var  valueField = this.state.datarow.value;
        if (fieldName==='price') valueField= this.state.datarow.qty * Number(value)
        else if (fieldName==='qty') valueField= this.state.datarow.price * Number(value)

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, value: valueField,
            }
        }
        this.setState(nextState);
    }
    
    render() {
        return (
            //editable..
            <Grid sx={{justifyContent: {xs: 'center', md: 'left'}}}>

                <BaseList history={this.props.history} caption=' ' 
                    endPointFilter={TransactionModel.endPointFilterList2()} model={TransactionModel} onLoadAll={this.onLoadAllTransaction} disableView/>

                {!this.state.datarow.product &&
                <BaseView id={this.props.productId} caption=''
                    model={ProductModel} onLoad={this.onLoadProduct}/>
                }
                {this.state.datarowTransaction?.id === 0 && this.state.datarowTransaction?.customer > 0 && this.state.datarowTransaction?.name && !this.state.datarowTransaction?.transactiontype && !this.state.errors &&
                <TransactionCreate history={this.props.history} caption=' ' transactiontypeType='sales' datarow={this.state.datarowTransaction} onError={this.onError} save onSave={this.onSaveTransaction} disableView />
                }

                {this.state.datarowTransaction?.id > 0 && this.props.productId > 0 &&
                <BaseCreateEdit id={0} caption=' ' buttonCaption=' ' successCaption={this.state.isCart? 'Product add to cart.' : ' '}
                    model={Model} endPointFilter={Model.endPointFilterList(this.props.productId, this.state.datarowTransaction.id, 'draft')} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError} validations={this.validations} 
                    save={this.state.save} delete={this.state.datarow.qty === 0} onSave={this.onSave} buttonOnBottom disableAutoBack disableBackButton >
                    
                    {this.state.datarow.productQtymax !== 1 &&
                    <>
                    <InputNumber name='qty' label='Jumlah pesanan' value={this.state.datarow.qty} error={this.state.errors?.qty} onChange={this.onChange} />
                    <InputMoney name='value' label='Sub total' value={this.state.datarow.price * this.state.datarow.qty} error={this.state.errors?.value} onChange={this.onChange} readOnly/>
                    </>
                    }
                    {this.state.datarow.productProducttypeType === 'events' &&
                    <>
                    {this.state.datarow.productSchedule?.length > 0 &&
                    <InputPicklist name='schedule' label='Tentukan Jadwal' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                        <SchedulePicklist productId={this.state.datarow.product} currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule}/>
                    </InputPicklist>
                    }
                    {this.state.datarow.productSchedule?.length === 0?
                    <InputDate name='startdate' label='Tentukan Tanggal' value={this.state.datarow.startdate} error={this.state.errors?.startdate} onChange={this.onChange}/>            
                    
                    : this.state.datarow.schedule > 0 &&
                    <InputDate name='startdate' label='Tentukan Tanggal' value={this.state.datarow.startdate} error={this.state.errors?.startdate} disablePast disableTime disableDay={this.state.datarow.scheduleDisableday} onChange={this.onChange}/>            
                    }
                    <Input name='name' label='Judul' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                    <InputMultiline name='description' label='Ringkasan Masalah' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                                    
                    </>
                    }
                    <Grid marginTop={3}>
                    <Button type='contained' label={this.isMobile? 'Masukan Keranjang' : ''} textTransform='capitalize' startIcon='shopping_cart' sx={{ paddingRight: 1, marginRight: 1}} onClick={() => this.onClickSave(true)}/>    
                    <Button type='contained' label='Lanjut Bayar' textTransform='capitalize' onClick={() => this.onClickSave(false)}/>    
                    </Grid>
                </BaseCreateEdit>
                }

            </Grid>
            
        );
    }     
     
}